<script setup lang="ts">
import { computed, useTemplateRef } from "vue";
import { css } from "./css";
import { NuxtRoutedPage } from "~/components/nuxt-routed-page";
import { WebFooter } from "~/components/web-footer";
import { WebHeader } from "~/components/web-header";
import { useSticky } from "~/composables/use-sticky";
import { useHeaderHeight } from "~/composables/use-header-height";
import { useNavigation } from "~/composables/use-navigation";

const { route } = useNavigation();

const showHeader = computed(() => true);
const showFooter = computed(() => {
  if (route.value.name === "order") {
    return false;
  }

  return true;
});

const headerEl = useTemplateRef("headerEl");

const { isSticky } = useSticky(headerEl);

const { initHeaderObserver } = useHeaderHeight();
initHeaderObserver(headerEl);
</script>

<template>
  <div :class="css()">
    <div
      v-show="showHeader"
      ref="headerEl"
      :class="[css('header'), isSticky && css('header', 'shadowed')]"
    >
      <WebHeader />
    </div>
    <div :class="css('content')">
      <NuxtRoutedPage />
    </div>
    <WebFooter v-show="showFooter" :class="css('footer')" />
  </div>
</template>

<style lang="scss" scoped>
.layouts-web-responsive {
  display: flex;
  flex-direction: column;
  min-width: 100dvw;
  min-height: 100dvh;

  &__header {
    position: sticky;
    top: 0;
    z-index: 5;

    &--shadowed {
      box-shadow: var(--elevation-level-1);
    }
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;

    > * {
      width: 100%;
    }
  }

  &__footer {
    margin-bottom: var(--spacing-md);
  }
}
</style>
